import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';


Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

import { ModalPlugin } from 'bootstrap-vue';
Vue.use(ModalPlugin);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');


// import VueScrollmagic from 'vue-scrollmagic'

// mounted() {
//   Vue.use(VueScrollmagic, {
//     vertical: true,
//     globalSceneOptions: {},
//     loglevel: 2,
//     refreshInterval: 100
//   })

//   // create a scene
//   this.$scrollmagic.Scene({
//       triggerElement: "#margot-title",
//       triggerHook: 0.9, // show, when scrolled 10% into view
//       duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
//       offset: 0 // move trigger to center of element
//   })
//   .setClassToggle("#margot-title", "visible") // add class to reveal
//   .addIndicators() // add indicators (requires plugin)
//   .addTo(controller);
// }
